export default __webpack_public_path__ + "static/media/mongodb.a8889d62.png";